import { createFileRoute } from "@tanstack/react-router";
import { HomePageView } from "@/features/home";

export const Route = createFileRoute("/home")({
	component: HomePageView,
});
